import './CollectionCard.css';

export const CollectionCard = ({ title, color, icon, intro, path }) => {
  const colorClasses = {
    blue: 'card-blue',
    pink: 'card-pink',
    green: 'card-green',
    orange: 'card-orange'
  };

  return (
    <a 
      href={path}
      target="_blank"
      rel="noopener noreferrer"
      className={`collection-card-interactive ${colorClasses[color]}`}
    >
      <div className="card-header-interactive">
        <div className={`card-icon-interactive ${color}`}>
          {icon}
        </div>
        <h3 className="card-title-interactive">{title}</h3>
      </div>
      <p className="card-intro">{intro}</p>
      <button className="card-btn">Découvrir →</button>
    </a>
  );
};
